/* eslint-disable */
import Helper from "../../common/Helper";
import CharaBase from "../../common/CharaBase";

class CharaHuman extends CharaBase {
  constructor(scene) {
    super(scene);
  }

  //------------------------------------
  // Setup Mesh
  //------------------------------------
  setupMeshs() {
    //Mesh Setting
    this.mesh = this.scene.getNodeByID("Human");
    this.scene.getNodeByID("Human_Bag").parent = this.mesh;
    this.scene.getNodeByID("Human_Bag_Fire_L").parent = this.mesh;
    this.scene.getNodeByID("Human_Bag_Fire_R").parent = this.mesh;
    this.scene.getNodeByID("Human_Bag_Nozzle_L").parent = this.mesh;
    this.scene.getNodeByID("Human_Bag_Nozzle_R").parent = this.mesh;

    //Submit Animations
    this.setAnimationGroup(
      this.scene.animationGroups[0].name,
      this.scene.animationGroups[0]
    );
    this.setAnimationGroup(
      this.scene.animationGroups[1].name,
      this.scene.animationGroups[1]
    );

    //Default Transform
    this.mesh.position.y = 40;
    this.mesh.position.z = 50;
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    this.mesh.rotation.x += 0.01;
    this.mesh.rotation.y += 0.01;

    this.mesh.position = Helper.updateTransform(
      this.mesh.position,
      this.position,
      this.positionSpeed
    );
  }
}
export default CharaHuman;
